/* NOIREN — comportements : mode de mouvement, parallaxe, filtres, variantes, panier AJAX. Aucune dépendance. */
(() => {
  const root = document.documentElement;
  root.classList.replace('no-js', 'js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection || {};
  const weak = (navigator.hardwareConcurrency || 8) <= 4 || (navigator.deviceMemory || 8) <= 2 || conn.saveData === true;
  const touch = matchMedia('(pointer: coarse)').matches;
  const lite = reduce || weak;
  root.dataset.motion = lite ? 'lite' : 'full';
  const pointerFx = !lite && !touch;
  const raf = (fn) => { let t = false; return (...a) => { if (!t) { t = true; requestAnimationFrame(() => { t = false; fn(...a); }); } }; };

  const hero = document.querySelector('[data-hero]');
  if (hero && !lite) {
    if (pointerFx) {
      const move = raf((x, y) => { hero.style.setProperty('--mx', x.toFixed(3)); hero.style.setProperty('--my', y.toFixed(3)); });
      hero.addEventListener('pointermove', (e) => { const r = hero.getBoundingClientRect(); move(((e.clientX - r.left) / r.width - .5) * 2, ((e.clientY - r.top) / r.height - .5) * 2); });
      hero.addEventListener('pointerleave', () => { hero.style.setProperty('--mx', 0); hero.style.setProperty('--my', 0); });
    }
    const scroll = raf(() => { const r = hero.getBoundingClientRect(); hero.style.setProperty('--p', Math.min(1, Math.max(0, -r.top / (r.height * .8))).toFixed(3)); });
    addEventListener('scroll', scroll, { passive: true });
  }

  document.querySelectorAll('[data-country-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-filter-form]').forEach((form) => {
    let t; form.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => form.requestSubmit(), 350); });
  });

  const desk = matchMedia('(min-width: 900px)');
  const syncFilters = () => document.querySelectorAll('details[data-filters]').forEach((d) => { if (desk.matches) d.open = true; });
  syncFilters(); desk.addEventListener('change', syncFilters);

  document.querySelectorAll('[data-product]').forEach((box) => {
    const main = box.querySelector('[data-main-image] img');
    box.querySelectorAll('[data-thumb]').forEach((b) => b.addEventListener('click', () => {
      if (main) { main.src = b.dataset.large; main.removeAttribute('srcset'); main.alt = b.dataset.alt || ''; }
      box.querySelectorAll('[data-thumb]').forEach((x) => x.setAttribute('aria-current', x === b));
    }));
    const form = box.querySelector('[data-product-form]');
    if (!form) return;
    const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    const idInput = form.querySelector('[name=id]'), price = box.querySelector('[data-price]'), btn = form.querySelector('[data-add]'), msg = form.querySelector('[data-msg]');
    const label = btn.querySelector('[data-label]') || btn, btnPrice = btn.querySelector('[data-btn-price]');
    const buyNow = form.querySelector('[name=return_to]');
    const groups = [...form.querySelectorAll('.options')];
    const read = () => groups.map((g) => { const i = g.querySelector('input:checked'); return i ? i.value : null; });
    const fits = (v, sel, upto) => v.available && v.options.every((o, i) => i > upto || o === sel[i]);
    const sync = (e) => {
      let sel = read();
      const gi = e ? groups.findIndex((g) => g.contains(e.target)) : -1;
      if (gi >= 0 && !variants.some((v) => fits(v, sel, sel.length - 1))) {
        const alt = variants.find((v) => fits(v, sel, gi));
        if (alt) {
          alt.options.forEach((o, i) => { const inp = [...groups[i].querySelectorAll('input')].find((x) => x.value === o); if (inp) inp.checked = true; });
          sel = read();
        }
      }
      groups.forEach((g, gi) => g.querySelectorAll('input').forEach((inp) => {
        inp.disabled = !variants.some((v) => v.options[gi] === inp.value && fits(v, sel, gi - 1));
      }));
      groups.forEach((g, gi) => { const val = g.querySelector('.options__val'); if (val && sel[gi]) val.textContent = sel[gi]; });
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      if (!v) return;
      idInput.value = v.id;
      if (price) price.innerHTML = v.onsale ? '<s>' + v.compare + '</s>' + v.price : v.price;
      if (btnPrice) btnPrice.innerHTML = v.price + (v.onsale ? ' <s>' + v.compare + '</s>' : '');
      btn.disabled = !v.available; label.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      if (buyNow) buyNow.disabled = !v.available;
      history.replaceState(null, '', '?variant=' + v.id);
    };
    form.addEventListener('change', sync); sync();
    form.addEventListener('submit', async (e) => {
      if (!window.theme || !window.fetch) return;
      if (e.submitter && e.submitter.name === 'return_to') return;
      e.preventDefault(); btn.disabled = true;
      const say = (text, error) => { if (msg) { msg.textContent = text; msg.classList.toggle('is-error', error); } };
      try {
        const r = await fetch(theme.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          say(err.description || err.message || btn.dataset.error, true);
          btn.disabled = false;
          return;
        }
        const cart = await (await fetch(theme.routes.cart)).json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        say(btn.dataset.added, false);
      } catch (err) { form.submit(); return; }
      btn.disabled = false;
    });
  });
})();
